import { FIREWEATHER_API_URL, isLocal, GEOSERVER_URL, GEOSERVER_URL_BOM, APP_BASE_URL } from "../env";
// import { GoogleCharts } from 'google-charts';

import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils.js";

import { getJSON } from '../utils';

// ! Okta

import {
    authClient
} from '../okta-auth';

// ! Details chart Helpers

import {
    drawLocationHeader
} from './helpers/details-panel/draw-location-header';

import {
    drawSummaryTable
} from './helpers/details-panel/draw-summary-table';

import {
    drawTemperatureChart
} from './helpers/details-panel/draw-temperature-chart';

import {
    drawRHChart
} from './helpers/details-panel/draw-relative-humidity-chart';

import {
    drawWindSpeedChart
} from './helpers/details-panel/draw-wind-speed-chart';

import {
    drawWindDirTable
} from './helpers/details-panel/draw-wind-direction-table';

import {
    drawFdrColumnChart
} from './helpers/details-panel/draw-fdr-column-chart';

import {
    drawFbiColumnChart
} from './helpers/details-panel/draw-fbi-column-chart';

// ! Observation panel helpers

import {
    drawStationHeader
} from './helpers/observations-panel/draw-station-header';

import {
    drawStationDataGrid
} from './helpers/observations-panel/draw-station-data-grid';

import {
    drawWHistoryTemperatureChart
} from './helpers/observations-panel/draw-w-history-temperature-chart';

import {
    drawWHistoryRelativeHumidityChart
} from './helpers/observations-panel/draw-w-history-rel-humid-chart';

import {
    drawWHistoryWindSpeedChart
} from './helpers/observations-panel/draw-w-history-wind-speed-chart';

import {
    drawWHistoryWindDirChart
} from './helpers/observations-panel/draw-w-history-wind-dir-chart';

import {
    drawStationSubPanel
} from './helpers/observations-panel/draw-station-sub-panel';

// ! Prescribed burn table

import {
    drawPbTable
} from './helpers/prescribed-burn-panel/draw-pb-table';

// ! Chart

import {
    drawChartHeader
} from './helpers/observations-panel/draw-chart-header';

import {
    drawChartLocationHeader
} from './helpers/details-panel/draw-chart-location-header';

// ! Loading spinner

import {
    generateLoadingSpinner
} from '../loading-spinner/loading-spinner';

/**
 * Generates the forecast url, which contains:
 * DAILY
 * - Temperature
 * - FBI
 * - FDR
 * - KBDI
 * - Grass
 * - Curing
 * 
 * HOURLY
 * -Temperature
 * - Humidity
 * - Direction
 * - Speed
 * - FBI
 * - FDR
 * - DF
 * 
 * Run the url in your browser if you want to see whats returned
 * @param {*} latVal 
 * @param {*} lonVal 
 * @returns 
 */
function getForecastDataUrl(latVal, lonVal){
    return `${FIREWEATHER_API_URL}/forecast-data/?lat=${latVal}&lon=${lonVal}`;
}

// ! CHARTS

const chartHeight = `160px`;

// ! ASSEMBLY FUNCTIONS

/**
 * Generates WMS Forecast DOM object for the details panel
 * in the fwe.html page.
 * This may also be used on the chart.html page
 */
function generateWMSForecastPanel(detailsContainerId, data, mapPoint) {
    // Clear the container
    const detailsContainer = $(`#${detailsContainerId}`);
    detailsContainer.empty();

    // Draw location header (and associated buttons)
    drawLocationHeader(detailsContainer, mapPoint);

    // Daily max data table
    drawSummaryTable(data.Daily, detailsContainer);

    // Temperature line chart
    drawTemperatureChart(data.Hourly, detailsContainer, chartHeight);

    // Relative humidity line chart
    drawRHChart(data.Hourly, detailsContainer, chartHeight);

    // Wind speed line chart
    drawWindSpeedChart(data.Hourly, detailsContainer, chartHeight);

    // Wind direction table
    drawWindDirTable(data.Hourly, detailsContainer, chartHeight);

    // FDR bar chart
    drawFdrColumnChart(data.Hourly, detailsContainer, chartHeight);

    // FBI bar chart
    drawFbiColumnChart(data.Hourly, detailsContainer, chartHeight);
}

function generateObservationsForecastPanel(detailsContainerId, stationData) {
    // Clear the container
    const detailsContainer = $(`#${detailsContainerId}`);
    detailsContainer.empty();

    // Title
    drawStationHeader(detailsContainer, stationData);

    // Data grid
    drawStationDataGrid(detailsContainer, stationData);

    // Wind gust, raingfall 
    drawStationSubPanel(detailsContainer, stationData)

    // Temperature (deg C)
    drawWHistoryTemperatureChart(detailsContainer, stationData, chartHeight);
   
    // Relative Humidity (%)
    drawWHistoryRelativeHumidityChart(detailsContainer, stationData, chartHeight);

    // Wind Speed (km/h)
    drawWHistoryWindSpeedChart(detailsContainer, stationData, chartHeight);

    // Wind Direction
    drawWHistoryWindDirChart(detailsContainer, stationData, chartHeight);
}

function generatePrescribedBurnPanel(detailsContainerId, data, mapPoint) {
    // Clear the container
    const detailsContainer = $(`#${detailsContainerId}`);
    detailsContainer.empty();
    
    drawPbTable(data, detailsContainer);
}

function generateChartWeatherStationPanels(stationData, panel1, panel2, height) {
    
    // INFO
    drawChartHeader(panel1, stationData);

    drawStationDataGrid(panel1, stationData);

    drawStationSubPanel(panel1, stationData);

    // CHARTS
    
    // Temperature (deg C)
    drawWHistoryTemperatureChart(panel2, stationData, height);
   
    // Relative Humidity (%)
    drawWHistoryRelativeHumidityChart(panel2, stationData, height);

    // Wind Speed (km/h)
    drawWHistoryWindSpeedChart(panel2, stationData, height);

    // Wind Direction
    drawWHistoryWindDirChart(panel2, stationData, height);
}

function generateDetailChartPanels(data, panel1, panel2, height, latVal, lonVal) {

    // CHART 1
    drawChartLocationHeader(panel1, latVal, lonVal);

    drawSummaryTable(data.Daily, panel1, height);

    drawTemperatureChart(data.Hourly, panel1, height);

    drawRHChart(data.Hourly, panel1, height);

    // Compute the number of arrows for the wind dir table
    let wwidth = $(window).width();

    // This should be in line with whatever the @media rule is for charts.css
    if(wwidth >= 901) {
        wwidth /= 2;
    }
    
    // Subtract 2 for buffer
    const numArrows = Math.floor(wwidth / 18) - 2;

    // CHART 2
    drawWindSpeedChart(data.Hourly, panel2, height);

    drawWindDirTable(data.Hourly, panel2, height, numArrows);

    drawFdrColumnChart(data.Hourly, panel2, height);

    drawFbiColumnChart(data.Hourly, panel2, height);
}

// ! FINAL ASSEMBLY FUNCTION

export function observationChartPanelsAssemblyFunction(weatherStationId, panel1, panel2, height, callback) {
    // Get the access token
    const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();
    
    $.ajax({
        url: `${FIREWEATHER_API_URL}/weather-stations/${weatherStationId}/data`,
        headers: {
            'Authorization': `Bearer ${accessToken.accessToken}`
        },
        method: "GET",
        success: function(response) {
            generateChartWeatherStationPanels(response, panel1, panel2, height);
            callback();
        },
        error: function(xhr, status, error) {
            console.error("Error:", error);
        }
    })
}

export function detailChartPanelsAssemblyFunction(latVal, lonVal, panel1, panel2, height, callback) {
    // Get the access token
    const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();

    $.ajax({
        url: getForecastDataUrl(latVal, lonVal),
        headers: {
            'Authorization': `Bearer ${accessToken.accessToken}`
        },
        method: 'GET',
        success: function(response) {
            generateDetailChartPanels(
                    response,
                    panel1,
                    panel2,
                    height,
                    latVal,
                    lonVal);
            callback();
            
        },
        error: function(xhr, status, error) {
            console.error(error);
        }
    })
}

/**
 * Generates the details panel DOM element.
 * 
 * ! NOTE
 * This function takes a different design philosophy to the original
 * `queries.js` file.
 * 
 * That file contained a bunch of methods which attached graphs to a
 *  bunch of HTML templates, and then mounted those that DOM object in 
 *  the DOM of the RHS panel in the fwe.html page.
 * 
 * That SEEMS like a good idea (and granted if it were documented correctly
 *  it probably would be a good idea), however, said layout is extremely
 *  confusing to maintain (i.e. too many functions within functions that
 *  return a partial result that are then used by other functions).
 * 
 * In the spirit of "admirable simplicity", the decision was made to 
 *  stage this function (like a production line), and explicitly
 *  outsource functionality to private helper functions.
 * 
 * While this results in a chunkier function, since everything is in one 
 *  place, and segmented, it should be easier to understand, and thus 
 *  maintain.
 * ! END NOTE
 *  
 * @param {*} e 
 * @param {*} spatialRef 
 * @param {*} currentLayerObj 
 * @param {*} chartContainerId - The ID of the container that will house 
 *      the google chart.
 */
export function generateDetailsPanel(
        e, 
        spatialRef, 
        currentLayerObj, 
        chartContainerId) {
    // Get the geographic points that was clicked
    let x, y;

    if(spatialRef.isWebMercator) {
        var mapPt = webMercatorUtils.webMercatorToGeographic(e.mapPoint);
        x = mapPt.x;
        y = mapPt.y;
    } else {
        x = e.mapPoint.x;
        y = e.mapPoint.y;
    }

    const lonVal = e.mapPoint.longitude;
    const latVal = e.mapPoint.latitude; 

    // Clear the element containing the table data
    const chartContainer = $(`#${chartContainerId}`);
    chartContainer.empty();

    const spinnerContainer = $(`<div class="query-spinner-style"></div>`);
    spinnerContainer.append(generateLoadingSpinner());

    // Display the loading spinner
    $(`#${chartContainerId}`).html(spinnerContainer);

    // Get the access token
    const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();

    // Figure out what kind of panel needs to be generated
    if(currentLayerObj.layerType === 'Observation' || currentLayerObj.geoserverId === 'incident_forecast') { //Captures the weather station layer as well as the Incident Weather Forecast layer
        // Observations panel
        /* This requires the following:
            1. A WMS query to get the station id
            2. An API request 
        */

        // Do a WMS Query here
        const params = new URLSearchParams({
            'SERVICE': 'WMS',
            'VERSION': '1.1.1',
            'REQUEST': 'GetFeatureInfo',
            'FORMAT': 'image/png',
            'TRANSPARENT': 'true',
            'QUERY_LAYERS': `fireweather:${currentLayerObj.geoserverId}`,
            'LAYERS': `fireweather:${currentLayerObj.geoserverId}`,
            'INFO_FORMAT': 'application/json',
            'exceptions': 'application/json',
            'FEATURE_COUNT': '50',
            'X': '50',
            'Y': '50',
            'SRS': 'EPSG:4326',
            'WIDTH': '101',
            'HEIGHT': '101',
            'BBOX': `${Number(lonVal) - 0.1},${Number(latVal) - 0.1},${Number(lonVal) + 0.1},${Number(latVal) + 0.1}`
        });
        const url = `${GEOSERVER_URL}?${params.toString()}`;
        getJSON(url, {'Authorization': `Bearer ${accessToken.accessToken}`}, function(results) {
            if(results['numberReturned'] > 0) {
                const featureId = results['features'][0]['id'].split('.').at(-1);

                //Geoserver request for proxied BoM link to the Incident Weather Forecast page for the requested feature
                if (currentLayerObj.geoserverId === 'incident_forecast') {
                    chartContainer.empty();
                    window.open(`/viewer-bom.html?incident_weather/${featureId}.shtml`, "_blank");
                }
                else {
                    // ! API Query for weather station data
                    $.ajax({
                        url: `${FIREWEATHER_API_URL}/weather-stations/${featureId}/data`,
                        method: "GET",
                        headers: {
                            'Authorization': `Bearer ${accessToken.accessToken}` 
                        },
                        success: function(response) {
                            generateObservationsForecastPanel(chartContainerId, response);
                        },
                        error: function(xhr, status, error) {
                            console.error("Error:", error);
                        }
                    })
                    return;
                }
            }
        })
        .fail(() => console.error("Oh no, something went wrong :^("));
    } else if(currentLayerObj.layerType === 'Forecast_WMS') {
        // Forecast panel
        if(currentLayerObj.geoserverId === 'RFS_PBFT_SFC') {
            var input = { region: 'NSW', lat: latVal, lon: lonVal };
            $.ajax({
                type: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken.accessToken}` 
                },
                url: `${FIREWEATHER_API_URL}/prescribed-burn/?lat=${latVal}&lon=${lonVal}&state=NSW`,
                dataType: 'json',
                data: input,
                success: (response) => {
                    generatePrescribedBurnPanel(chartContainerId, 
                            response, 
                            e.mapPoint);
                },
                error: function(xhr, ajaxOptions, error) {
                    console.error("Error: ", error);
                }
            });
            return;
        }

        // Get the forecast data
        $.ajax({
            url: getForecastDataUrl(e.mapPoint.latitude, e.mapPoint.longitude),
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken.accessToken}` 
            },
            success: function(response) {
                generateWMSForecastPanel(
                    chartContainerId, 
                    response,
                    e.mapPoint); 
            },
            error: function(xhr, status, error) {
                console.error(error);
                chartContainer.empty();
                const errorLoading = $(`<div class="query-spinner-style"></div>`);
                errorLoading.text("Error querying side panel");
                chartContainer.append(errorLoading);

            }
        });
        return;
    } else {
        // No panel
    }   
}